import { api } from '../client';

export interface LaborRate {
  id: string;
  category_id: string | null;
  product_id: string | null;
  rate_per_kg: string;
  scope: 'default' | 'category' | 'product';
  created_at: string | null;
  updated_at: string | null;
}

export interface LaborRateListResponse {
  request_id: string;
  rates: LaborRate[];
}

export interface LaborRateDetailResponse {
  request_id: string;
  rate: LaborRate;
}

export function createStockLaborRatesApi() {
  return {
    list: (): Promise<LaborRateListResponse> => api.webAdmin.get('/stock/labor-rates'),

    upsertDefault: (ratePerKg: string): Promise<LaborRateDetailResponse> =>
      api.webAdmin.put('/stock/labor-rates/default', { rate_per_kg: ratePerKg }),

    upsertCategory: (categoryId: string, ratePerKg: string): Promise<LaborRateDetailResponse> =>
      api.webAdmin.put(`/stock/labor-rates/category/${categoryId}`, { rate_per_kg: ratePerKg }),

    upsertProduct: (productId: string, ratePerKg: string): Promise<LaborRateDetailResponse> =>
      api.webAdmin.put(`/stock/labor-rates/product/${productId}`, { rate_per_kg: ratePerKg }),

    delete: (rateId: string): Promise<{ request_id: string; success: boolean }> =>
      api.webAdmin.delete(`/stock/labor-rates/${rateId}`),
  };
}
